module.exports = __webpack_public_path__ + "static/bg-header-finance-calculator-3e7ffbde0dfdcfb0d6353bb8357c4a6b.svg";